import { useState } from "react";
import { useTranslation } from "react-i18next";

import { systemLabelKey } from "../../catalogs/characterSystemCatalog";
import { DAMAGE_TYPES } from "../../catalogs/damageTypes";
import DraggableModal from "../../components/layout/DraggableModal/DraggableModal";
import DiceFormulaInput from "../../components/utils/DiceFormulaInput/DiceFormulaInput";

const ITEM_TYPES = ["weapon", "ammunition", "armor", "gear", "magic", "consumable"];
const WEAPON_TYPES = ["melee", "ranged"];
const ARMOR_TYPES = ["helmet", "armor", "shield", "other"];

const AddItemModal = ({ isOpen, onClose, onSubmit, formData, setFormData }) => {
  const { t } = useTranslation();
  const [formError, setFormError] = useState("");
  const handleChange = (event) => {
    const { name, value } = event.target;
    setFormData((previous) => ({
      ...previous,
      [name]: value,
      ...(name === "type" && value === "armor" && !previous.armorType ? { armorType: "armor" } : {}),
      ...(name === "type" && value === "weapon" && !previous.weaponType ? { weaponType: "melee" } : {}),
    }));
  };
  const handleSubmit = () => {
    if (!formData.type) {
      setFormError(t("inventory.form.typeRequired"));
      return;
    }
    onSubmit(formData);
    onClose();
    setFormError("");
  };
  const option = (group, value) => <option key={value} value={value}>{t(systemLabelKey(group, value))}</option>;

  return isOpen && (
    <DraggableModal isVisible={isOpen} onClose={onClose} headerText={t("inventory.form.editItem")}>
      <label className="inventory-form-field">{t("inventory.form.itemName")}<input type="text" name="name" value={formData.name} onChange={handleChange} /></label>
      <label className="inventory-form-field">{t("inventory.form.itemType")}
        <select name="type" value={formData.type} onChange={handleChange}>
          <option value="">{t("inventory.form.selectItemType")}</option>
          {ITEM_TYPES.map((value) => option("itemTypes", value))}
        </select>
      </label>
      <label className="inventory-form-field">{t("inventory.form.weight")}<input type="number" min="0" name="weight" value={formData.weight} onChange={handleChange} /></label>
      <label className="inventory-form-field">{t("inventory.form.quantity")}<input type="number" min="0" step="1" name="amount" value={formData.amount ?? 1} onChange={handleChange} /></label>
      <label className="inventory-form-field">{t("inventory.form.cost")}<input type="number" min="0" name="price" value={formData.price} onChange={handleChange} /></label>
      {formData.type === "weapon" && <>
        <label className="inventory-form-field">{t("inventory.form.weaponCategory")}<select name="weaponType" value={formData.weaponType ?? "melee"} onChange={handleChange}>{WEAPON_TYPES.map((value) => option("weaponTypes", value))}</select></label>
        <label className="inventory-form-field">{t("inventory.form.attackModifier")}<input type="number" name="modifier" value={formData.modifier ?? ""} onChange={handleChange} /></label>
        <label className="inventory-form-field">{t("inventory.form.range")}<input type="text" name="range" value={formData.range ?? ""} onChange={handleChange} placeholder="5 ft." /></label>
        <div className="weapon-formulas-row">
          <DiceFormulaInput formData={formData} label={t("inventory.form.damage")} onChange={handleChange} prefix="damage" />
          <DiceFormulaInput formData={formData} label={t("inventory.form.criticalHit")} onChange={handleChange} prefix="crit" />
        </div>
        <label className="inventory-form-field">{t("inventory.form.damageType")}<select name="damageType" value={formData.damageType ?? ""} onChange={handleChange}><option value="">{t("inventory.form.selectDamageType")}</option>{DAMAGE_TYPES.map((value) => option("damageTypes", value))}</select></label>
      </>}
      {formData.type === "ammunition" && <>
        <DiceFormulaInput formData={formData} label={t("inventory.form.additionalDamage")} onChange={handleChange} prefix="damage" />
        <label className="inventory-form-field">{t("inventory.form.damageType")}<select name="damageType" value={formData.damageType ?? ""} onChange={handleChange}><option value="">{t("inventory.form.selectDamageType")}</option>{DAMAGE_TYPES.map((value) => option("damageTypes", value))}</select></label>
      </>}
      {formData.type === "armor" && <>
        <label className="inventory-form-field">{t("inventory.form.armorSlot")}<select name="armorType" value={formData.armorType ?? "armor"} onChange={handleChange}>{ARMOR_TYPES.map((value) => option("armorTypes", value))}</select></label>
        <label className="inventory-form-field">{t("inventory.form.armorClassModifier")}<input type="number" name="armorClass" value={formData.armorClass ?? ""} onChange={handleChange} /></label>
      </>}
      <label className="inventory-form-field">{t("inventory.form.notes")}<textarea name="notes" value={formData.notes} onChange={handleChange} /></label>
      {formError && <p role="alert" className="inventory-form-error">{formError}</p>}
      <button type="button" onClick={handleSubmit}>{t("inventory.form.save")}</button>
    </DraggableModal>
  );
};

export default AddItemModal;
